export default __webpack_public_path__ + "static/media/avatars.37dd9560.png";